<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useDefaultFieldValues } from '@/components/form-builder/field-settings/useDefaultFieldValues'

interface Props {
  field: {
    isRadio: boolean
    defaultValue?: boolean | null
    uniqueKey: () => string
  }
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (
    e: 'modify-field',
    payload: {
      propertyKey: string
      fieldValue: boolean | null
      key: string
    },
  ): void
}>()

const activeToggleType = ref(props.field.isRadio ? 'radio' : 'checkbox')

watch(
  () => props.field.isRadio,
  (newIsRadio) => {
    activeToggleType.value = newIsRadio ? 'radio' : 'checkbox'
  },
  { immediate: true },
)

const { showDefaultValue, toggleDefaultValue } = useDefaultFieldValues(props.field)

function changeToggleType() {
  emit('modify-field', {
    propertyKey: 'isRadio',
    fieldValue: activeToggleType.value === 'radio',
    key: props.field.uniqueKey(),
  })
}
</script>

<template>
  <vs-wrapper space="small">
    <v-radio-group
      v-model="activeToggleType"
      label="Choose a visual type: "
      mandatory
      row
      @change="changeToggleType"
    >
      <v-radio label="Checkbox" value="checkbox"></v-radio>
      <v-radio label="Radio" value="radio"></v-radio>
    </v-radio-group>

    <v-checkbox
      :input-value="showDefaultValue"
      label="Default Value"
      @change="toggleDefaultValue"
    />

    <div v-if="showDefaultValue">
      <v-switch
        :input-value="field.defaultValue || false"
        :value="field.defaultValue || false"
        inset
        label="Default to True"
        @change="(value) => (field.defaultValue = value)"
      />
    </div>
  </vs-wrapper>
</template>
